export const FETCH_DISCIPLINE_LIST_REQUEST = "FETCH_DISCIPLINE_LIST_REQUEST";
export const FETCH_DISCIPLINE_LIST_SUCCESS = "FETCH_DISCIPLINE_LIST_SUCCESS";
export const FETCH_DISCIPLINE_LIST_FAILURE = "FETCH_DISCIPLINE_LIST_FAILURE";
